import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUserGroupsByUserId = (userId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.USER_MANAGEMENT.GET_USER_GROUPS_BY_USERID(userId)
  );
};

export default getUserGroupsByUserId;
